// http://develop.cxy61.com:8080/#/ActivityApply/vwktk26ftq39ghgz
<template>
  <div class="activityApply">
    <div class="activityDetail">
      <div class="picture">
        <img
          class="activityimg"
          :src="currentActivity && currentActivity.photo"
        />
      </div>
      <img class="back" :src="images.back" @click="goBack()" />
    </div>
    <div class="activityApplyContainer">
      <img class="signupIcon" :src="images.join" />
      <!-- <span
        style="font-size:20px;color:#FE0B00;text-align: center;display: block;margin-bottom: 40px;"
        >本比赛适合至少学习C++1年以上的学员</span
      > -->

      <div class="userinfoContainer">
        <div class="header">
          <span class="text"
            >请填写或核查信息，此部分信息用于生成获奖证书。</span
          >
          <span class="btn" @click="changeUserinfoClickEvent()">{{
            change_userinfo ? "保存" : "修改"
          }}</span>
        </div>
        <div class="wrap">
          <div class="rowWrap">
            <span class="label">真实姓名</span>
            <div class="right">
              <div class="input">
                <input
                  placeholder="请填写真实姓名"
                  v-model="realname"
                />
              </div>
              <div class="tip">真实姓名用于系统生成证书，请填写正确名字。</div>
            </div>
          </div>
          <div class="rowWrap">
            <span class="label">就读学校</span>
            <div class="right">
              <div class="input">
                <input
                  placeholder="请填写就读学校"
                  v-model="school"
                  :readonly="!change_userinfo"
                  :class="`${!change_userinfo ? 'notallow' : ''}`"
                />
              </div>
            </div>
          </div>
          <div class="rowWrap">
            <span class="label">证件照</span>
            <div class="right">
              <div class="uploadWrap">
                <div
                  class="uploadPhoto"
                  v-if="logo.localUrl"
                  :style="{
                    width: '100px',
                    height: `${100 * cropper_proportion}px`
                  }"
                >
                  <ProgressImg :logo="logo" />
                </div>
                <div
                  class="upload"
                  @click="uploadPhoto()"
                  :class="`${!change_userinfo ? 'notallow' : ''}`"
                >
                  <div class="line1"></div>
                  <div class="line2"></div>
                </div>
                <input
                  ref="uploadPhoto"
                  required
                  accept="image/*"
                  type="file"
                  style="display:none;"
                  @change="uploadPhoto_change"
                />
              </div>

              <div class="tip">请上传2寸证件照照片(413x626)</div>
            </div>
          </div>
        </div>
      </div>

      <div class="addressContainer">
        <div class="header">
          <span class="text"
            >请填写或核查信息，如若获奖，获奖证书将邮寄此地址。</span
          >
          <span class="btn" @click="changeAddressClickEvent()">{{
            change_address ? "保存" : "修改"
          }}</span>
        </div>
        <div class="wrap">
          <div class="rowWrap">
            <span class="label">收件人</span>
            <div class="right">
              <div class="input">
                <input
                  placeholder="请填写收件人姓名"
                  v-model="linkman"
                  :readonly="!change_address"
                  :class="`${!change_address ? 'notallow' : ''}`"
                />
              </div>
            </div>
          </div>
          <div class="rowWrap">
            <span class="label">手机号</span>
            <div class="right">
              <div class="input">
                <input
                  placeholder="请填写收件人手机号"
                  v-model="telephone"
                  :readonly="!change_address"
                  :class="`${!change_address ? 'notallow' : ''}`"
                />
              </div>
            </div>
          </div>
          <div class="rowWrap">
            <span class="label">地址</span>
            <div class="right">
              <div class="input">
                <input
                  placeholder="请填写详细地址"
                  v-model="address"
                  :readonly="!change_address"
                  :class="`${!change_address ? 'notallow' : ''}`"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        :class="`submit ${can_publish ? '' : 'disable'}`"
        @click="submitEvent()"
      >
        报名
      </div>

      <ShadowView ref="shadowView">
        <CropperImg
          @cropperEvent="cropperEvent"
          :src="cropper_url"
          :proportion="cropper_proportion"
        />
      </ShadowView>

      <ShadowView ref="dingShadowView">
        <div class="dingContainer">
          <div class="logoView" style="position:relative;">
            <img class="logo" :src="images.logo" />
            <span class="text">下载钉钉，加入钉钉考试群</span>
          </div>

          <div class="dingWrap">
            <div class="left">
              <span class="text">1、用手机下载钉钉</span>
              <span class="text">2、扫描右侧二维码，加入钉钉考试群</span>
              <span class="text">3、请保存好二维码</span>
            </div>
            <div class="right">
              <div class="qrcodeView">
                <img class="qrcode" :src="qrcode_url" :style="{width:`120px`, height:`${1087/878*120}px` }"/>
              </div>
            </div>
          </div>
        </div>
      </ShadowView>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ProgressImg from "@/components/ProgressImg";
import { Utils, UPLOAD_SINGLE_IMAGE } from "@/utils";

import { types as ToastTypes } from "@/store/modules/toast";
import { types as ActivityTypes } from "@/store/modules/activity.js";
import { types as AddressTypes } from "@/store/modules/address.js";
import { types as LoginTypes } from "@/store/modules/login";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

import { IMG_ACTIVITY_SIGNUP, IMG_BACK, IMG_ACTIVITY_LOGO } from "@/assets";
import CropperImg from "../components/CropperImg";
import ShadowView from "../components/ShadowView";

export default {
  name: "AcitivityApply",
  components: {
    ProgressImg,
    CropperImg,
    ShadowView
  },
  data() {
    return {
      images: {
        join: IMG_ACTIVITY_SIGNUP,
        back: IMG_BACK,
        logo: IMG_ACTIVITY_LOGO
      },
      // 活动号
      number: "",
      realname: "",
      school: "",
      linkman: "",
      telephone: "",
      address: "",
      logo: {
        localUrl: "",
        progress: 0,
        remoteUrl: "",
        showProgress: false
      },
      can_publish: false,
      change_userinfo: false,
      change_address: false,

      cropper_proportion: 626 / 413,
      cropper_url: "",

      qrcode_url: ""
    };
  },
  watch: {
    userInfo(value) {
      // console.log("watch_Userinfo");
      if (value) {
        this.realname = value.realname;
        this.school = value.school;
        this.logo.localUrl = value.photo;
        this.logo.remoteUrl = value.photo;
        this.logo.showProgress = false;
        this.setPublishBtnState();
      }
    },
    currentAddress(value) {
      // console.log("watch_currentAddress");
      if (value) {
        this.linkman = value.linkman;
        this.telephone = value.telephone;
        this.address = value.shipping_address;
        this.setPublishBtnState();
      }
    }
  },
  computed: {
    ...mapState({
      currentActivity: state => state.activity.currentActivity,
      userInfo: state => state.login.userInfo,
      currentAddress: state => state.address.currentAddress
    })
  },
  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW
    }),
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
      fetchDetail: ActivityTypes.FETCH_DETAIL_ACTIVITY,
      fetchApplyActivity: ActivityTypes.FETCH_APPLY_ACTIVITY,
      fetchOwnInfo: LoginTypes.FETCH_USERINFO,
      fetchUpdateWhoamI: LoginTypes.FETCH_UPDATE_USERINFO,
      fetchAddressList: AddressTypes.FETCH_ADDRESS_LIST,
      fetchUpdateAddress: AddressTypes.FETCH_UPDATE_ADDRESS
    }),
    ...Utils,

    // 返回事件
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else if (window.history.length === 1) {
        if (location.origin.includes("coding61.com")) {
          location.href = "https://www.coding61.com/index/CogaSelect";
        } else {
          location.href = "https://app.bcjiaoyu.com/index/CogaSelect";
        }
      }
    },

    // 判断报名按钮状态
    setPublishBtnState() {
      if (
        this.realname &&
        this.school &&
        this.logo.remoteUrl &&
        this.linkman &&
        this.telephone &&
        this.address
      ) {
        this.can_publish = true;
      } else {
        this.can_publish = false;
      }
    },

    // 修改用户信息
    changeUserinfoClickEvent() {
      if (this.change_userinfo === true) {
        // 点了保存
        // 发请求
        let dic = {
          realname: this.realname,
          school: this.school,
          photo: this.logo.remoteUrl
        };
        this.fetchUpdateWhoamI({ data: dic });
      }
      this.change_userinfo = !this.change_userinfo;
    },

    // 修改地址
    changeAddressClickEvent() {
      if (this.change_address === true) {
        // 点了保存
        // 发请求
        let dic = {
          linkman: this.linkman,
          telephone: this.telephone,
          shipping_address: this.address
        };
        this.fetchUpdateAddress(dic);
      }
      this.change_address = !this.change_address;
    },

    // ------CropperImg 组件回传事件
    cropperEvent(data) {
      this.$refs.shadowView.hideShadowView();
      this.uploadPhoto_remote(data);
    },
    // 上传 logo 图点击事件
    uploadPhoto() {
      if (this.change_userinfo) {
        this.$refs.uploadPhoto.click();
      }
    },
    uploadPhoto_change(e) {
      let files = e.target.files;
      // 先去裁剪图片
      this.cropper_url = window.URL.createObjectURL(files[0]);
      this.$refs.shadowView.showShadowView();
    },
    uploadPhoto_remote(data) {
      let imgSrc = window.URL.createObjectURL(data);
      this.logo.localUrl = imgSrc;
      this.logo.showProgress = true;

      UPLOAD_SINGLE_IMAGE(
        data,
        url => {
          this.logo.remoteUrl = url;
          this.logo.showProgress = false;
        },
        progress => {
          this.logo.progress = parseInt(progress);
        }
      );
    },

    // 报名
    submitEvent() {
      if (this.can_publish) {
        // 发起请求
        this.fetchApplyActivity({ number: this.number }).then(response => {
          if(response.group_qrcode){
          this.qrcode_url = response.group_qrcode.url;
          this.$refs.dingShadowView.showShadowView();
          }else{
            this.showToast({"message":"报名成功"})
          }
        });
      }
    }
  },
  created() {},
  destroyed() {},
  mounted() {
    this.number = this.$route.params.number;
    this.fetchDetail({ pk: this.number });
    this.dependLoginStatus("no_toast").then(() => {
      this.fetchOwnInfo();
      this.fetchAddressList();
    });
  }
};
</script>

<style lang="less" scoped>
.activityApply {
  background-color: #ffffff;
  width: 100%;
  /* height: 100%; */
  min-width: 1100px;
  min-height: 100%;
  background-size: 100%;
  position: relative;
  .activityApplyContainer {
    width: 1000px;
    margin: 0 auto;
    z-index: 200;
    position: relative;
    background-color: #ffffff;
    padding-bottom: 30px;
  }
}
.back {
  height: 60px;
  display: block;
  position: absolute;
  top: 20px;
  left: 20px;
  // left: calc((100% - 1000px) / 2);
}
.activityDetail {
  width: 100%;
  position: relative;
  .activityimg {
    display: block;
    width: 100%;
    min-height: 100px;
    background-color: palegoldenrod;
  }
}
.signupIcon {
  width: 50%;
  margin-left: 25%;
  display: block;
  margin-top: 50px;
  margin-bottom: 10px;
}

.addressContainer,
.userinfoContainer {
  margin-bottom: 50px;
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    margin-bottom: 5px;
    .text {
      color: #999999;
      font-size: 16px;
    }
    .btn {
      color: #ff7b00;
      font-size: 18px;
      cursor: pointer;
    }
  }
  .wrap {
    background-color: #fdf5ef;
    border: solid 1px #fbcb9f;
    border-radius: 20px;
    padding: 40px 40px;
    display: flex;
    flex-direction: column;

    .rowWrap {
      width: 100%;
      display: flex;
      flex-direction: row;
      margin-bottom: 30px;
      justify-content: flex-start;
      align-items: flex-start;

      .label {
        width: 100px;
        height: 40px;
        background-color: #ff7b00;
        // padding: 0px 8px;
        line-height: 40px;
        text-align: center;
        font-size: 15px;
        color: #ffffff;
        margin-right: 10px;
        border-radius: 5px;
      }
      .right {
        flex: 1;
        .input {
          flex: 1;
          background-color: #ffffff;
          border: solid 1px #ebebeb;
          height: 40px;
          padding: 0 10px;
          border-radius: 5px;
          input {
            border: none;
            width: 100%;
            height: 100%;
          }
        }
        .tip {
          margin-top: 10px;
          color: #999999;
          font-size: 12px;
        }
        .uploadWrap {
          display: flex;
          flex-direction: row;
          .uploadPhoto {
            // 413*626
            width: 100px;
            height: 100px;
            margin-right: 20px;
          }
          .upload {
            border: solid 1px #ebebeb;
            width: 100px;
            height: 100px;
            border-radius: 5px;
            background-color: #ffffff;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            &.notallow {
              cursor: not-allowed;
            }
            .line1 {
              position: absolute;
              width: 35px;
              height: 2px;
              background-color: #d3d1d1;
              top: 50%;
            }
            .line2 {
              width: 2px;
              height: 35px;
              background-color: #d3d1d1;
            }
          }
        }
      }
    }
  }
}

.submit {
  background-color: #ff7b00;
  width: 120px;
  border-radius: 30px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  font-size: 20px;
  margin-left: calc((100% - 100px) / 2);
  cursor: pointer;
  &.disable {
    background-color: #e1e1e1;
  }
}
.notallow {
  cursor: not-allowed;
}

.dingContainer {
  margin: auto;
  width: 500px;
  background: #ffffff;
  // height: 400px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  .logoView {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .text {
      color: rgb(255, 228, 0);
      font-size: 30px;
      position: absolute;
      margin-top:-30px;
    }
  }
  .logo {
    width: 100%;
    display: block;
    margin-bottom: 20px;
    // height: 100px;
  }
  .dingWrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px;
    .left {
      display: flex;
      flex-direction: column;
      flex: 1;
      .text {
        color: #333333;
        font-size: 16px;
        margin-bottom: 10px;
      }
    }
    .right {
      .qrcodeView {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .qrcode {
        width: 120px;
        height: 120px;
        margin-bottom: 10px;
      }
      .text {
        color: #333333;
        font-size: 14px;
      }
    }
  }
}
</style>
